"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;

require("@albelli/arc-3/lib/core.css");

require("@albelli/arc-3/lib/icon.css");

var _classnames2 = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Icon = function Icon(_ref) {
  var className = _ref.className,
      name = _ref.name,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["className", "name", "size"]);

  var classes = (0, _classnames2.default)("arc3-icon", className, _defineProperty({}, "icon--".concat(size), size));
  return (// have to set font-feature-settings with inline style, because this property gets broken in css file after webpack
    _react.default.createElement("i", _extends({
      className: classes,
      style: {
        fontFeatureSettings: '"liga"'
      }
    }, props), name)
  );
};

exports.Icon = Icon;
Icon.propTypes = {
  /** Custom CSS classes */
  className: _propTypes.default.string,

  /** Valid ARC3 icon name */
  name: _propTypes.default.string,

  /** Icon size */
  size: _propTypes.default.oneOf(["ultra-small", "extra-small", "small", "medium", "large", "extra-large"])
};